import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

export const complianceAdapter = createEntityAdapter({
  selectId: (item) => item.name,
});

const initialState = complianceAdapter.getInitialState({
  loading: false,
  error: null,
});

export const complianceSlice = createSlice({
  name: 'compliance',
  initialState,
  reducers: {},
});

export default complianceSlice.reducer;
